/*
 * @Author: Suroc
 * @Date: 2024-07-12 21:43:30
 * @LastEditTime: 2025-01-15 16:43:38
 * @Description: 
 */
const en = {
  // 头部导航-√
  Header: {
    SuperMarket: "FLST Super Market",
    Connect: "Connect Wallet",
  },
  // 底部导航-√
  Footer: {
    Home: "Home",
    Mining: "Mining",
    Profit: "Profit",
    Team: "Team",
    FLST: "FLST",
  },
  // 首页-√
  Home: {
    Account: "Account",
    Share: "Share",
    Reference: "Reference",
    BindWallet: "Bind Wallet",
    Ecological: "Mining Machine",
    Pledge: "Pledge",
    Conduct: "Financing",
    ToLoan: "ToLoan",
    Metaverse: "Metaverse",
    ChainGame: "ChainGame",
    ShoppingMall: "ShoppingMall",
    SwapBut: "Explore",
  },
  // 矿机-√
  Mint: {
    OnSale: "On Sale",
    StopSelling: "Stop Selling",
    F1MiningMachine: "F1 Mining Machine",
    F2MiningMachine: "F2 Mining Machine",
    F3MiningMachine: "F3 Mining Machine",
    F4MiningMachine: "F4 Mining Machine",
    F5MiningMachine: "F5 Mining Machine",
    Authorize: "Authorize",
    BuyNow: "Buy Now",
    PurchaseFLST: "Purchase FLST",
  },
  // 收益-√
  Profit: {
    Hold: "Holding value",
    UnStatic: "StaticIncome",
    UnDynamics: "DynamicIncome",
    StaticTotal: "StaticIncome(BeenOn)",
    DynamicTotal: "DynamicIncome(BeenOn)",
    MyIncome: "Total Income",
    Receive: "Receive",
    MyRecord: "My Income Record",
    Money: "Amount-U",
    Quantity: "Tokens",
    Time: "Time",
  },
  // 团队-√
  Team: {
    SuperiorAddress: "Superior Address",
    Performance: "Performance",
    TeamSize: "Team size",
    Referral: "Direct Referral",
    Direct: "My Team",
    Address: "Address",
    Money: "Amount-U",
    Time: "Time",
    CopyLink: "Copy Link",
  },
  // 公共消息弹窗-√
  Prompt: {
    Admin: "Unauthorized Access",
    AdminInfo: "Get Exceptions",
    AdminModified: "Modified Successfully",
    AdminModification: "Modification Failed",
    PurchaseSucceeded: "Purchase succeeded",
    PurchaseFailed: "Purchase failed",
    BindingSucceeded: "Binding Succeeded",
    BindingFailed: "Binding Failed",
    ConnectWallet: "Please connect the wallet first",
    Confirm: "Confirm",
    Cancel: "Cancel",
    GoGetIt: "Go get it",
    SoldOut: "Sold out",
    Receive: "Received Successfully",
    NotYetDev: "Not Yet Open",
    NewIssueSuccess: 'Received Successfully',
    NewIssueError: 'Collection Failed',
    TransactionErr: 'Transaction failed',
    BalanceErr: 'Insufficient balance',
    USDTBalanceErr: 'USDT balance insufficient',
    FLSTBalanceErr: 'FLST balance insufficient',
    AllowanceErr: 'Insufficient allowance',
    AllowanceSuccess: 'Authorization succeeded',
    InviteInfo1: 'You pass through',
    InviteInfo2: 'Invitation to visit, is there a binding relationship?',
    ProfitInfo: "You haven't received any income, you can buy it after receiving it",
    ProfitInfo2: 'You have no unclaimed benefits',
    Fail:"FAIL"
  },
  nongC: {
    "Home": "Home",
    "Farm": "Farm",
    "Trade": "Trade",
    "NFT": "NFT",
    "Mine": "Mine",

    "Share": "Share",
    "Referrer": "Referrer",
    "Lv": "Current Level",
    "Bal": "Balance",
    "CHZSoil": "Green",
    "KSTSoil": "Yellow",
    "SRZSoil": "Brown",
    "GRZSoil": "Grey",
    "Plant": "Plant",
    "Harvest": "Harvest",
    "Buy": "Buy",
    "TaxRt": "Tax Rate",
    "Prc": "Price",
    "Qty": "Quantity",
    "Mkt": "Market",
    "Mint": "Mint",
    "BBox": "Blind Box",
    "BuyBBox": "Buy Box",
    "SellOrder": "Sell",
    "SellMarket": "List for Sale",
    "Cancel": "Cancel",
    "Claim": "Claim",
    "ContriDiv": "Contribution Dividend",
    "EquityDiv": "Equity Dividend",
    "EquityVal": "Equity Value",
    "ContriVal": "Contribution Value",
    "DivList": "Dividend List",
    "MyTeam": "My Team",
    "MyDown": "My Downline",
    "MyUpss": "My Upline",
    "TeamMaxLv": "Team Max Level",
    "DirectRefPerf": "Direct Referral Performance",
    "Bind": "Bind",
    "Sale":"Sell",
    "HistoryPrice":"Current:price",
    "Error":"Error"

  },
  common: {
    "crzfh": "C Cert Dividend",
    "contri": "Contrib Dividend",
    "contriAmount": "Dividend Amount",
    "myArea": "My Area",
    "myBind": "My Binding",
    "noBind": "No Binding",
    "ktAdress": "Pioneer Address",
    "crz": "C Cert",
    "qyz": "Equity",
    "none": "None",
    "payAmount": "Pay Amount",
    "sale": "Sell",
    "amount": "Total Harvest",
    "investment": "Planting",
    "released": "Already Harvested",
    "cycle": "Cycle",
    "plantTime": "Planting Time",
    "lastHarvest": "Harvestr end Time",
    "harvest": "Harvest",
    "hgt": "Green",
    "lgt": "Yellow",
    "zgt": "Brown",
    "huigt": "Grey",
    "plantNow": "Plant Now",
    "makeSure": "Confirm",
    "czzqsh": "Processing...",
    "ljqdts": "Check-in Days:",
    "dh": "Exchange",
    "wqd": "Not Checked",
    "dqd": "To Check-in",
    "kfzqdd": "Developing...",
    "gqbzwjrqx": "No Wallet Access",
    "zwkf": "Not Open",
    "sqcg": "Auth Success",
    "sqsb": "Auth Failed",
    "zzcg": "Mint Success",
    "zzsb": "Mint Failed",
    "dkcg": "Open Success",
    "dksb": "Open Failed",
    "cg": "Success",
    "sb": "Failed",
    "open": "Open",
    "buy": "Buy",
    "free": "Free",
    "zzhqsj": "Fetching Data",
    "zwtjr": "No Referrer",
    "destroy": "Burned",
    "sywcc": "Unmined",
    "dhfm": "10d 23h 15m 15s",
    "xcrq": "Next",
    "zwzsdnft": "No NFT for Sale",
    "mc": "Name:",
    "fortyfiveDay": "Days",
    "uybind": "Bind This",
    "zgyqmm": "Invite Code?",
    "zwyqm": "No Invite Code",
    "wcxdyqm": "Code Not Found",
    "bindSuccess": "Bind Done",
    "zwkf": "Not Open",
    "lq": "Claim",
    "fail": "Failed",
    "mygdl": "No More",
    "jine": "Amount:",
    "shijian": "Time:",
    "tq": "Withdraw",
    "tqd": "Withdrawn",
    "dsf": "To Release",
    "zzsf": "Releasing",
    "sfwc": "Release Done",
    "jz": "Value:",

    "zz": "planting", 
     "zq": "cycle",
     "Hour":"Hour",
     "Day":"Day",
     "Min":"Min",
      "Sec":"Sec",
      "limit":"Remain",
      "tq":"receive",

      "dlq": "To Be Harvested",
      "Harvest2": "One-click collect",
      "St": "Stolen",
      "Telegram": "TG",
      "Home": "Official website",
      "CChat": "CChat",
      "Knowlage": "Knowledge base",
      "SALE": "Sell",
      "BUY": "Buy",

      "availableBalance": "Available Balance",
      "dailyClaimsLeft": "Daily Claims Left",
      "userClaimsLeft": "Your Claims Left",
      "userClaims": "Your Claims",
       "history":"history",
       "My sales": "My sales",
       "token": "Token",
       "price": "Price", 
       "total": "Total"

      
  },
  signatureGuard: {
    connectWallet: "Connect Wallet",
    connectDescription: "Please connect your wallet to verify your identity and access your personal information",
    connecting: "Connecting...",
    connect: "Connect Wallet",
    signatureRequired: "Signature Required",
    signatureDescription: "For security purposes, please sign to verify your wallet address",
    currentWallet: "Current Wallet",
    signing: "Signing...",
    sign: "Sign Verification",
    verificationFailed: "Verification Failed",
    retry: "Retry",
    disconnect: "Disconnect",
    walletConnected: "Wallet Connected Successfully",
    connectionFailed: "Wallet Connection Failed",
    connectionError: "Connection Error",
    noWalletAddress: "Unable to get wallet address",
    noProvider: "No wallet provider detected",
    signatureSuccess: "Signature Verification Successful",
    userRejected: "User rejected signature",
    signatureError: "Signature Failed",
    noSignMessage: "Missing signature message",
    addressMismatch: "Signature address does not match current address",
    verificationError: "Verification Error",
    walletDisconnected: "Wallet Disconnected"
  }
}
export default en;